
export class Globals {
    public static gridSize = 10;
    public static maxImageHeight = 400;
    public static maxImageWidth = 600;
}



// WEBPACK FOOTER //
// ./code/Globals.ts